export default{
    notification: {},

    validateNotification: false,
}
